import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { keys } from '@/api/queryKeys';
import { triageApi } from '../api/triageApi';
import type { TriageDetail } from '../api/types';

export function useTriageItem(uuid: string | null | undefined) {
  return useQuery({
    queryKey: keys.triage.item(uuid ?? ''),
    queryFn: ({ signal }) => triageApi.getItem(uuid!, { signal }),
    enabled: uuid != null,
    staleTime: 60_000,
  });
}

export function useCreateTriageNote(uuid: string) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (text: string) => triageApi.createNote(uuid, text),
    onSuccess: (note) => {
      queryClient.setQueryData<TriageDetail>(keys.triage.item(uuid), (prev) =>
        prev ? { ...prev, notes: [...(prev.notes ?? []), note] } : prev,
      );
      void queryClient.invalidateQueries({ queryKey: keys.triage.item(uuid) });
    },
  });
}
